import React from "react";
import { FormControl, FormLabel, TextField } from "@mui/material";

/**
 * BillingField
 *
 * Labelled billing TextField used by BillingForm. Does not decide layout;
 * the caller passes width / className / style.
 *
 * Props:
 *   label                 – field label
 *   value / onChange      – controlled input
 *   error / required / type / data-testid
 *   fullWidth             – FormControl fullWidth
 *   inputFullWidth        – TextField fullWidth
 *   formControlClassName / formControlStyle / labelClassName
 */
function BillingField({
  label,
  value,
  onChange,
  error = false,
  type = "text",
  "data-testid": dataTestId,
  required = false,
  fullWidth = false,
  inputFullWidth = false,
  formControlClassName,
  formControlStyle,
  labelClassName,
}) {
  return (
    <FormControl
      className={formControlClassName}
      style={formControlStyle}
      fullWidth={fullWidth}
    >
      <FormLabel className={labelClassName}>{label}</FormLabel>
      <TextField
        variant="outlined"
        size="small"
        type={type}
        value={value ?? ""}
        onChange={onChange}
        error={error}
        required={required}
        fullWidth={inputFullWidth}
        data-testid={dataTestId}
      />
    </FormControl>
  );
}

export default BillingField;
